<template>
  <div>
    <el-select
        v-model="selectedLocation"
        filterable
        placeholder="Select timezone"
        @change="updateTimezone">
      <el-option-group
          v-for="group in timezones"
          :key="group.label"
          :label="group.label">
        <el-option
            v-for="(timezone, index) in group.options"
            :key="index"
            :value="timezone.label">
          <span><i class="el-icon-location" /></span>
          <span>{{ timezone.label }} ({{ timezone.tz }}) </span>
        </el-option>
      </el-option-group>
    </el-select>
    <span
        class="el-input el-input--small"
        style="width: fit-content; font-size: 13px;">
      {{ currentLocation.tz }}
    </span>
    <span>
      <el-tooltip
          class="info"
          content="The customer's timezone is selected by default">
        <i class="el-icon-info" />
      </el-tooltip>
    </span>
  </div>
</template>

<script>
import momentTZ from "moment-timezone";
import { createNamespacedHelpers as namespace } from "vuex";
const { mapGetters: accountGetters } = namespace("db/account");
const { mapGetters, mapActions } = namespace("ui");
import permission from "@/mixins/permission";
import { isEmpty } from "lodash";

export default {
  name: "TimeZoneSelector",
  mixins: [permission],

  data() {
    return {
      vars: null,
      timezones: [],
      timezonesArray: [],
      currentLocation: { tz: momentTZ.tz.guess(), label: "Local Timezone" },
      currentDefaultLocation: {
        tz: momentTZ.tz.guess(),
        label: "Local Timezone",
      },
      currentUserLocation: {
        tz: momentTZ.tz.guess(),
        label: "Local Timezone",
      },
      selectedLocation: "",
    };
  },
  computed: {
    ...mapGetters(["locale", "currentTimezone"]),
    ...accountGetters(["customerId"]),
  },
  watch: {
    customerId(value, preValue) {
      let isNewUser = value !== preValue;
      this.fetchTimeZones(isNewUser);
    },
  },
  created() {
    this.vars = process.env;
    this.fetchTimeZones();
  },
  // mounted() {
  //   this.selectedLocation = this.currentTimezone;
  // },
  methods: {
    ...mapActions(["setLocale", "setUserTimezone"]),
    updateLocale(locale) {
      this.setLocale(locale).then((locale) => {
        this.$i18n.locale = locale;
      });
    },
    fetchTimeZones(isNewUser = false) {
      let customerLocations = this.$store.getters["db/account/locations"];

      function mapLocation(loc) {
        if (!loc || !loc.address || !loc.address.timezone) {
          return { tz: "UTC", label: "UTC / Default" };
        }

        return { tz: loc.address.timezone, label: loc.name };
      }

      // If the customer has any location
      if (!isEmpty(customerLocations) && customerLocations[0].location_id) {
        let customerTimeZones = customerLocations.map((loc) =>
          mapLocation(loc)
        );

        this.currentDefaultLocation.tz = customerTimeZones[0].tz;
        this.currentDefaultLocation.label = customerTimeZones[0].label;
        this.timezonesArray = customerTimeZones.concat([
          this.currentUserLocation,
        ]);
        this.timezones = [
          {
            label: "Customer Timezone(s)",
            options: customerTimeZones,
          },
          { label: "Local Timezone", options: [this.currentUserLocation] },
        ];
      } else {
        // If the customer has not locations we set user location as default
        this.currentDefaultLocation.tz = this.currentUserLocation.tz;
        this.currentDefaultLocation.label = this.currentUserLocation.label;
        this.currentLocation = this.currentUserLocation;
        this.selectedLocation = this.currentUserLocation;
        this.timezones = [
          { label: "Local Timezone", options: [this.currentUserLocation] },
        ];
      }
      let storedLabel = localStorage.getItem("locationTZ");
      if (storedLabel) {
        this.selectedLocation = storedLabel;
        this.currentLocation =
          this.timezonesArray.find((t) => {
            return t.label == this.selectedLocation;
          }) || {};
      }
      if (
        !this.currentLocation.tz ||
        isNewUser ||
        (!isNewUser && !storedLabel)
      ) {
        this.currentLocation = this.currentDefaultLocation;
        this.selectedLocation = this.currentLocation.label;
      }
      this.setUserTimezone({
        current: this.currentLocation,
      });
    },
    updateTimezone() {
      this.currentLocation = this.timezonesArray.find(
        (t) => t.label == this.selectedLocation
      );
      this.setUserTimezone({
        current: this.currentLocation,
      }).then(() => {
        this.$message({
          type: "success",
          message: this.$t("common.timezone_updated"),
        });
      });
    },
  },
};
</script>

<style lang="scss">
.el-dropdown-menu.el-popper {
  max-height: 200px !important;
  overflow: scroll !important;
}
footer {
  width: 100%;
  bottom: 0px;
  left: 0px;
  position: fixed;
  line-height: 40px;
  height: 40px;
  border-top: solid 2px #e4e4e4;
  font-size: 13px;
  text-align: center;
  background: #fff;
  z-index: 10000;
  .menu {
    ul {
      margin: 0;
      padding: 0;
      list-style: none;
      li {
        float: left;
        margin-right: 10px;
        &:last-child {
          margin-right: 0px;
        }
        a {
          cursor: pointer;
        }
      }
    }
  }
}
</style>
